import { Component, OnInit, Input } from '@angular/core'

@Component({
    selector: 'app-profile-info-streaks',
    templateUrl: './profile-info-streaks.component.html',
    styleUrls: ['./profile-info-streaks.component.scss'],
    standalone: false,
})
export class ProfileInfoStreaksComponent implements OnInit {
    @Input() attendanceScore: string
    @Input() compSessions: number = 0
    @Input() weeklyStreak: number = 0
    @Input() monthlyStreak: number = 0

    public scoreColor: string = 'black'

    constructor() {}

    ngOnInit() {
        this.setColor(this.attendanceScore)
    }

    setColor(value) {
        if (value) {
            let val = (100 - value) / 100
            let hue = ((1 - val) * 120).toString(10)
            this.scoreColor = ['hsl(', hue, ',100%,50%)'].join('')
        }
    }
}
